import React from 'react';
import { formatGold } from '../../utils/goldNotation';
import { formatDate } from '../../utils/transparency';

const ExpensesTable = ({ expenses, limit }) => {
  const rows = limit ? expenses.rows.slice(0, limit) : expenses.rows;

  if (expenses.rows.length === 0) {
    return <p className="text-gray-400 text-sm">Nenhuma despesa nos últimos 30 dias.</p>;
  }

  return (
    <div className="rounded-xl border border-white/10 overflow-hidden">
      <div className="hidden sm:grid grid-cols-[1fr_auto_auto] gap-4 px-4 py-2 bg-white/5 text-gray-400 text-xs uppercase">
        <span>Descrição</span><span>Data</span><span className="text-right">Valor (Gold)</span>
      </div>
      {rows.map((row, index) => (
        <div key={`${row.createdAt}-${index}`} className="grid grid-cols-1 sm:grid-cols-[1fr_auto_auto] gap-1 sm:gap-4 px-4 py-3 border-t border-white/5">
          <span className="text-white">{row.description}</span>
          <span className="text-gray-400 text-sm">{formatDate(row.createdAt)}</span>
          <span className="text-red-400 font-semibold sm:text-right" title={Number(row.amount).toLocaleString('pt-BR')}>
            {formatGold(row.amount)}
          </span>
        </div>
      ))}
      <div className="flex justify-between px-4 py-3 bg-white/5 border-t border-white/10">
        <span className="text-white font-bold">Total (últimos 30 dias)</span>
        <span className="text-white font-bold" title={Number(expenses.total).toLocaleString('pt-BR')}>
          {formatGold(expenses.total)}
        </span>
      </div>
    </div>
  );
};

export default ExpensesTable;
